// Inline meta glyphs for the fixture expanded detail's venue · referee ·
// attendance footer — taken from the Component Library design. Inline SVG so
// they can take the brand colour via currentColor.
//
// The goal glyph next to goalscorers is NOT one of these: it used to be a
// bespoke inline SVG here (`BallIcon`), but its fine three-panel detail
// became an indistinct blob at the 12px it renders at (confirmed visually —
// see task-14 in .superpowers/sdd/2026-07-26-release-feedback-polish/).
// Fixture.tsx now reuses the shared per-tenant `ballIcon` asset (already used
// correctly elsewhere by lineupGlyphs.ts and MatchRow.tsx) instead.

export const PinIcon = () => (
  <svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path
      d="M6 1.25c-1.93 0-3.5 1.54-3.5 3.44 0 2.42 3.5 6.06 3.5 6.06s3.5-3.64 3.5-6.06c0-1.9-1.57-3.44-3.5-3.44z"
      stroke="currentColor"
      strokeWidth="1.1"
    />
    <circle cx="6" cy="4.7" r="1.25" fill="currentColor" />
  </svg>
);

export const WhistleIcon = () => (
  <svg width="15" height="13" viewBox="0 0 18 16" fill="currentColor" fillRule="evenodd" aria-hidden="true">
    <path d="M1.4 6.3h6.5a4.6 4.6 0 1 1 0 3.4H4.7v2.2a1 1 0 0 1-2 0V9.7H1.4a1.7 1.7 0 0 1 0-3.4zm10.8-1.5a1.05 1.05 0 1 0 0 2.1 1.05 1.05 0 0 0 0-2.1z" />
  </svg>
);

export const PeopleIcon = () => (
  <svg width="15" height="13" viewBox="0 0 20 14" fill="currentColor" aria-hidden="true">
    <circle cx="6.3" cy="3.4" r="2.5" />
    <path d="M1 12.4c0-2.6 2.1-4.4 5.3-4.4s5.3 1.8 5.3 4.4c0 .4-.3.6-.7.6H1.7c-.4 0-.7-.2-.7-.6z" />
    <circle cx="14.2" cy="4" r="2.1" />
    <path d="M13.2 7.7c3 .1 4.8 1.8 4.8 4.2 0 .3-.2.5-.5.5h-3.1c.2-.3.3-.7.3-1.1 0-1.4-.6-2.6-1.7-3.4l.2-.2z" />
  </svg>
);
